import axiosInstance from "../../utils/axiosInstance";

const awardService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/Award", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },

    getById: async (id) => {

        const response = await axiosInstance.get(`/Award/${id}`);

        return response.data;
    },

    create: async (data) => {

        const response = await axiosInstance.post(
            "/Award",
            data
        );

        return response.data;
    },

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/Award/${id}`,
            data
        );

        return response.data;
    },

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/Award/${id}`
        );

        return response.data;
    }

};

export default awardService;